import axios from "axios";
import { url } from "./utils/url";
import authHeader from "./utils/auth-header";

class MapApi {
  static async getGoogleMapsApiKey() {
    const result = await axios.get(`${url}/admin/maps`, {
      headers: authHeader(),
    });

    return result.data;
  }
}

export default MapApi;
